export default "__VITE_ASSET__7ea18e1b__"